import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { ajaxPost } from '../ajax'
import { loadStripeTerminal } from '@stripe/terminal-js'

function StripeTerminalConnect(props) {
  const { stripe, location, terminal, readers, connectedReader, onTerminalSet, onReadersFetch, onReaderConnect, 
    onError, onLoading } = props

  useEffect(() => {
    if (connectedReader) disconnectReader()
    loadTerminal()
  }, [stripe.location])

  useEffect(() => {
    if (connectedReader) return
    fetchReaders()
  }, [terminal])

  useEffect(() => {
    if (!connectedReader) return
    storeConnection()
  }, [connectedReader])

  useEffect(() => {
    if (readers.length)
      checkConnection() 
    else
      onLoading(false)
  }, [readers])

  const loadTerminal = async () => {
    const StripeTerminal = await loadStripeTerminal()
    const result = StripeTerminal.create({
      onFetchConnectionToken: fetchConnectionToken,
      onUnexpectedReaderDisconnect: () => onReaderConnect(null)
    })
    onTerminalSet(result)
  }

  const fetchConnectionToken = async () => {
    const data = { location_id: location, stripe_location: stripe.location }
    const response = await ajaxPost('/admins/payment/create_connection', data)
    const json = await response.json()
    return json.secret
  }

  const fetchReaders = async () => {
    if (!terminal || !stripe.location) return onReadersFetch([])
    onLoading(true)

    const useSimulator = stripe.use_simulator
    const config = { simulated: useSimulator, location: stripe.location }
    const discoverResult = stripe.location ? await terminal.discoverReaders(config) : { discoveredReaders: [] }
    if (discoverResult.error)
      processError(discoverResult.error.message)
    else
      onReadersFetch(discoverResult.discoveredReaders)
  }

  const disconnectReader = () => {
    terminal.disconnectReader()
    onReaderConnect(null)
  }

  const storeConnection = () => {
    const savedData = storedReaders()
    if (savedData[stripe.location] == connectedReader.id) return

    const newData = {...savedData, [stripe.location]: connectedReader.id}
    storeReaders(newData)
  }

  const checkConnection = () => {
    const savedData = storedReaders()
    const storedReaderId = savedData[stripe.location]
    if (storedReaderId) 
      restoreConnection(storedReaderId)
    else
      onLoading(false)
  }

  const restoreConnection = async (readerId) => {
    const savedReader = readers.find(reader => reader.id == readerId)
    if (!savedReader) {
      processError(`Unable to find stored reader: ${readerId}`)
      return
    }

    const connectResult = await terminal.connectReader(savedReader)
    if (connectResult.error) 
      processError(connectResult.error)
    else {
      onReaderConnect(savedReader)
      onLoading(false)
    }
  }

  const storedReaders = () => {
    return JSON.parse(localStorage.getItem('stripeReaders')) || {}
  }

  const storeReaders = (data) => {
    localStorage.setItem('stripeReaders', JSON.stringify(data))
  }

  const processError = (error) => {
    onError(error)
    onLoading(false)
  }

  return (<script src='https://js.stripe.com/terminal/v1/'></script>)
}

StripeTerminalConnect.propTypes = {
  stripe: PropTypes.object.isRequired,
  terminal: PropTypes.object,
  location: PropTypes.number.isRequired,
  readers: PropTypes.array.isRequired,
  connectedReader: PropTypes.object,
  onTerminalSet: PropTypes.func.isRequired,
  onReadersFetch: PropTypes.func.isRequired,
  onReaderConnect: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onLoading: PropTypes.func.isRequired
}

export default StripeTerminalConnect

